export default "__VITE_ASSET__DiraAf7g__"